module.exports = __webpack_public_path__ + "img/party-popper.ab5bac04.png";